// API Service for FantasticoMotors
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000/api';
const IMAGE_BASE_URL = process.env.VUE_APP_IMAGE_BASE_URL || API_URL.replace(/\/api\/?$/, '/');

class ApiService {
  // Get all cars
  async getAllCars(filters = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (filters.sold !== undefined) {
        queryParams.append('sold', filters.sold);
      }
      if (filters.make) {
        queryParams.append('make', filters.make);
      }
      if (filters.year) {
        queryParams.append('year', filters.year);
      }

      const url = queryParams.toString() 
        ? `${API_URL}/cars?${queryParams}` 
        : `${API_URL}/cars`;
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error('Failed to fetch cars');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching cars:', error);
      throw error;
    }
  }

  // Get single car by ID
  async getCarById(id) {
    try {
      const response = await fetch(`${API_URL}/cars/${id}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch car');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching car:', error);
      throw error;
    }
  }

  // Get car by reference number
  async getCarByRefnum(refnum) {
    try {
      const response = await fetch(`${API_URL}/cars/refnum/${refnum}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch car');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching car:', error);
      throw error;
    }
  }

  // Get available cars (not sold)
  async getAvailableCars() {
    return this.getAllCars({ sold: false });
  }

  // Get sold cars
  async getSoldCars() {
    return this.getAllCars({ sold: true });
  }

  // Get image URL
  getImageUrl(refnum, imageName, size = 'medium') {
    // Images are served by the backend under /img
    // size is kept for future use (we generate thumbnail_/medium_/large_ files)
    // but the current UI uses the original filename (e.g. car01.jpg).
    return `${IMAGE_BASE_URL}img/cars/${refnum}/${imageName}`;
  }

  // Get thumbnail URL
  getThumbnailUrl(refnum, imageName) {
    return this.getImageUrl(refnum, imageName, 'thumbnail');
  }

  // Get large image URL
  getLargeImageUrl(refnum, imageName) {
    return this.getImageUrl(refnum, imageName, 'large');
  }
}

export default new ApiService();
